import LedGlow from "@/components/apex/LedGlow";

/**
 * صورة مصغّرة لتصميم باب تملأ الحاوية (object-cover) مع تأثيرات التصميم
 * (مثل شريط الـ LED) مثبّتة في مكانها الصحيح فوق الصورة.
 * ratio = عرض/ارتفاع الصورة الأصلية، boxRatio = نسبة الحاوية.
 */
const DesignThumb = ({ item, alt = "", boxRatio = 3 / 4, className = "" }) => {
  const ratio = item.ratio || 848 / 1264;
  /* نحسب مستطيل الصورة الحقيقي داخل الحاوية (محاكاة object-fit: cover) */
  const fitStyle =
    ratio < boxRatio
      ? { left: 0, width: "100%", height: `${(boxRatio / ratio) * 100}%`, top: `${-((boxRatio / ratio - 1) / 2) * 100}%` }
      : { top: 0, height: "100%", width: `${(ratio / boxRatio) * 100}%`, left: `${-((ratio / boxRatio - 1) / 2) * 100}%` };

  return (
    <span className={`ap-thumb absolute inset-0 block ${className}`}>
      <span className="absolute block" style={fitStyle}>
        <img src={item.src} alt={alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full" />
        <LedGlow led={item.led} />
      </span>
    </span>
  );
};

export default DesignThumb;
